import { Users } from "lucide-react";
import SelectField from "./SelectField";

// Presentational dropdown for the owner filter. Pass the object returned by useTeamFilter().
// Usa Shadcn Select (SelectItem) para evitar <option> nativo y el warning de hidratación.
export const OwnerFilter = ({ tf }) => {
  if (!tf?.isLeader) return null;
  const options = [
    { value: "all", label: "Todos" },
    { value: tf.currentUserId, label: "Solo míos" },
    ...tf.members
      .filter((m) => m.id !== tf.currentUserId)
      .map((m) => ({ value: m.id, label: m.name || m.email })),
  ];
  return (
    <div className="inline-flex items-center gap-2">
      <Users className="w-4 h-4 text-navy/40" />
      <SelectField
        testid="owner-filter"
        value={tf.ownerId || "all"}
        onChange={(v) => tf.setOwnerId(v === "all" ? "" : v)}
        options={options}
        className="text-sm bg-white border border-navy/10 rounded-full px-4 py-2 h-auto min-w-[9rem]"
      />
    </div>
  );
};

export default OwnerFilter;
